








































import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ReportBackground extends Vue {
  @Prop() readonly doc!: any;
}
